import { jsx as n } from "react/jsx-runtime";
import { u as a } from "./index-6a632112.mjs";
import { f as c, a as m, c as t } from "./themes-5f0b3c3d.mjs";
import { f } from "./fontWeights-a25f8f91.mjs";
import { l as p } from "./lineHeights-72d3110c.mjs";
import "react";
const T = "DISCLOSURE_CONTENT_TEST_ID", d = a.div`
  text-align: left;
  font-family: ${c.inter};
  font-size: ${m.xsmall};
  font-weight: ${f.body.medium};
  letter-spacing: unset;
  line-height: ${p.xsmall};
  color: ${t.brandTwilight[0]};

  * {
    color: ${t.brandTwilight[600]};
  }
`, u = ({
  id: o,
  disclosureContent: s,
  disclosureTitleColor: i,
  className: e,
  style: r
}) => {
  const l = {
    color: i
  };
  return /* @__PURE__ */ n(
    d,
    {
      id: o,
      "data-testid": `${T}_disclosure_content`,
      className: e,
      style: { ...l, ...r },
      children: s
    }
  );
}, y = u;
export {
  y as Disclosures
};
